package dev.lingvo.ops.state

import dev.lingvo.ops.api.OpsApiException
import dev.lingvo.shared.ops.OpsIdentityDto

enum class OpsGuard { CHECKING, SIGNED_OUT, NOT_AN_OPERATOR, UNREACHABLE, ALLOWED }

fun opsGuard(sessionSignedIn: Boolean, identity: OpsIdentityDto?, failure: OpsApiException?): OpsGuard = when {
    !sessionSignedIn && failure == null -> OpsGuard.CHECKING
    !sessionSignedIn -> OpsGuard.SIGNED_OUT
    identity != null -> OpsGuard.ALLOWED
    failure?.status == 404 -> OpsGuard.NOT_AN_OPERATOR
    else -> OpsGuard.UNREACHABLE
}
